import 'iframe-resizer/js/iframeResizer.contentWindow';

window.$crisp = window.$crisp || [];
window.$crisp.push([
  'on',
  'chat:closed',
  function() {
    window.$crisp.push(['do', 'chat:hide']);
  }
]);
window.$crisp.push(['do', 'chat:hide']);

document.addEventListener('didScrollToTop', function() {
  if ('parentIFrame' in window) {
    window.parentIFrame.scrollToOffset(0, 0);
  }
});

// Inject URL of page embedding iframe
window.parent.postMessage(
  {
    type: 'queryParentLocation'
  },
  '*'
);

const ACTIONS = {
  setOriginUrl(url) {
    function appendHiddenInput() {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'submission[origin_url]';
      input.value = url;
      const form = document.querySelector('.js-bcs-form');
      // Handle when running inside the loading page
      if (form) {
        // Only handle cases where the backend hasn't set it
        if (!form.querySelector('[name="submission[origin_url"]')) {
          form.appendChild(input);
        }
      }
    }
    appendHiddenInput();
    // Ensure every slide has the origin_url injected
    document.addEventListener('didReplaceSlide', appendHiddenInput);
  }
};

window.addEventListener('message', function({ data }) {
  const { type, payload } = data;
  if (ACTIONS[type]) {
    ACTIONS[type](payload);
  }
});

const ATTR_QUERY_STRING = 'data-iframe-query-string';

document.addEventListener('didReplaceSlide', function({ target }) {
  const qs = target.getAttribute(ATTR_QUERY_STRING);
  if (qs) {
    window.parent.postMessage(
      {
        type: 'updateQueryString',
        payload: qs
      },
      '*'
    );
  }
});



// WEBPACK FOOTER //
// ./app/webpack/packs/iframeMessageReceiver.js